export default "/assets/images/waving-hand.90b025558981c8ce.png";